import React from 'react';
import TagInfo from '../../../../../../components/TagInfo';
import { IconWarningBlue } from '../../../../../../components/IconWarningBlue';

export const BloodProductInfo: React.FC = () => {
  return (
    <TagInfo
      icon={<IconWarningBlue />}
      info="Doadores com agendamento têm atendimento preferencial. Nossa tolerância para atrasos é de 10 min. Ao chegar após este intervalo estará sujeito a espera."
    />
  );
};
